import { get, post } from '@/api/core'

export namespace knowledge {
  /** 获取知识库列表 */
  export function list(p: { page: number; pageSize: number }) {
    return get('/knowledge/list', p)
  }

  export function submitForm(p: {
    customerName: string,
    companyName: string,
    position: string
    department: string
    email: string,
    location: string,
    blogUid: string
  }) {
    return post('/blog/customer_info/add', {}, p)
  }

  export function detail(p: { uid: string }) {
    return get<{
      data: {
        blogResourceIds: Array<{ fileUrl: string, fileName: string }>
      }
    }>('/blog/one', p)
  }
}